import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsEthernetSwitchesIP, OptionsConnectedDef, OptionsConnectedValueDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';


@Component({
  selector: 'ds-eth-switches',
  templateUrl: './ds-eth-switches.component.html',
  styleUrls: ['./ds-eth-switches.component.css']
})
export class DsEthSwitchesComponent implements OnInit, OnChanges {

  @Input() dsEthernetSwitchesObj: DsEthernetSwitchesIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsEthernetSwitchesObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

 cachedCommArch: any = {};
  filterCommArch() {
    let _id = this.dsEthernetSwitchesObj.parentDSRef.dsNumericalRelayIP.relayCommPort;
    if (this.cachedCommArch[_id] != null) {
      return this.cachedCommArch[_id];
    }
    this.cachedCommArch[_id] = this._dataService.ethCommArch.filter((_obj: OptionsConnectedValueDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedCommArch[_id] != null) {
      return this.cachedCommArch[_id];
    }
    var _result = !this._dataService.isGeneralEthCommArch(_id);
    this.cachedCommArch[_id] = _result;
    return _result;
  }

  
  cachedConfPopup: any = {};
  filterConfPopup(_ethSwCommArch) {
    let _result = this._dataService.ethCommArch.filter(opt => opt.optionId == _ethSwCommArch);
    if (_result && _result.length > 0) {
      this.dsEthernetSwitchesObj.ethSwConfPopup = _result[0].connectedValue;
    }
    else {
      this.dsEthernetSwitchesObj.ethSwConfPopup = "";
    }

  }

  sectionNoteChangePM(_event: any) {
    this.dsEthernetSwitchesObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsEthernetSwitchesObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsEthernetSwitchesObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Ethernet Switches", !!this.dsEthernetSwitchesObj.ethSwitches, " required to save Datasheet.")
      );
      if (this.dsEthernetSwitchesObj.ethSwitches_Enable) {
        _validList.push(
          new ValidationItem("Make", !!this.dsEthernetSwitchesObj.ethSwMake, " required to save Datasheet.")
        );
        if (this.dsEthernetSwitchesObj.isEthSwitchDetailsApplicable) {
          _validList.push(new ValidationItem("Communication Architecture Details", !!this.dsEthernetSwitchesObj.ethSwCommArchDetails, " required to save Datasheet."));
        } else {
          _validList.push(new ValidationItem("Communication Architecture", !!this.dsEthernetSwitchesObj.ethSwCommArch, " required to save Datasheet."));
        }
        _validList.push(
          new ValidationItem("Remote Communication", !!this.dsEthernetSwitchesObj.ethSwRemComm, " required to save Datasheet."),
          new ValidationItem("Auxiliary Supply", !!this.dsEthernetSwitchesObj.ethSwAuxSupply, " required to save Datasheet."),
          new ValidationItem("Power Supply 1", !!this.dsEthernetSwitchesObj.ethSwPwrSupply1, " required to save Datasheet.")
        );
        if (this.dsEthernetSwitchesObj.isAuxSupplyDualApplicable) {
          _validList.push(new ValidationItem("Power Supply 2", !!this.dsEthernetSwitchesObj.ethSwPwrSupply2, " required to save Datasheet."));
        }
        _validList.push(
          new ValidationItem("Coating", !!this.dsEthernetSwitchesObj.ethSwCoating, " required to save Datasheet."),
          new ValidationItem("Mounting", !!this.dsEthernetSwitchesObj.ethSwMounting, " required to save Datasheet.")
        );
      }
      _validList.push(new ValidationItem("EE Note", !!this.dsEthernetSwitchesObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsEthernetSwitchesObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsEthernetSwitchesObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsEthernetSwitchesObj.ethSwitches || !this.dsEthernetSwitchesObj.sectionNoteEE) return false;
      if (this.dsEthernetSwitchesObj.ethSwitches_Enable) {
        if (!this.dsEthernetSwitchesObj.ethSwMake ||
          !this.dsEthernetSwitchesObj.ethSwRemComm || !this.dsEthernetSwitchesObj.ethSwAuxSupply ||
          !this.dsEthernetSwitchesObj.ethSwPwrSupply1 || !this.dsEthernetSwitchesObj.ethSwCoating ||
          !this.dsEthernetSwitchesObj.ethSwMounting) {
          return false;
        }
        if (this.dsEthernetSwitchesObj.isEthSwitchDetailsApplicable) {
          if (!this.dsEthernetSwitchesObj.ethSwCommArchDetails) return false;
        } else {
          if (!this.dsEthernetSwitchesObj.ethSwCommArch) return false;
        }
        if (this.dsEthernetSwitchesObj.isAuxSupplyDualApplicable && !this.dsEthernetSwitchesObj.ethSwPwrSupply2) return false;
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsEthernetSwitchesObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsEthernetSwitchesObj.sectionNoteME) return false;
    }
    return true;
  }
}

